var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.auth.userInfo)?_c('side-bar'):_vm._e(),_c('div',{staticClass:"content ht-100v pd-0"},[(_vm.auth.userInfo)?_c('Header'):_vm._e(),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }